
<template>
	<div class="select-box">
		<van-nav-bar class="nav-box">
			<!-- <template #left>
				<span class="nav-left" @click="selectAll">{{
					list.length !== selectList.length ? $t('header.all') : $t('header.deselectAll')
				}}</span>
			</template> -->
			<template #title>
				<span class="nav-content">{{ $t('header.chooseEma') }}</span>
			</template>
			<template #right>
				<!-- 右侧功能 -->
				<span class="nav-right" @click="rightClick">{{ $t('common.cancel') }}</span>
			</template>
		</van-nav-bar>
		<div class="select-list">
			<ListItemBySelect
				v-for="item in list"
				:key="item.Id"
				:item="item"
				:FolderType="FolderType"
				@selectById="selectById"
				:isSelect="selectList.includes(item.Id)" />
		</div>
		<div class="select-bottom">
			<div class="select-btn-item">
				<i @click="handleClick" :class="hasSelect" class="iconfont icon-biaoji emil"></i>
				<!-- <img @click="handleClick" :class="hasSelect" src="../../assets/svg/select_delete.svg" alt="" /> -->
				<span @click="handleClick" :class="hasSelect">{{ tagTxt }}</span>
			</div>
			<div class="select-btn-item">
				<img :class="hasSelect" @click="deleteListById" src="../../assets/svg/select_delete.svg" alt="" />
				<span :class="hasSelect" @click="deleteListById">{{ $t('common.delet') }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import ListItemBySelect from '@/components/listItemBySelect'
export default {
	components: {
		ListItemBySelect
	},
	data() {
		return {
			selectList: []
		}
	},
	computed: {
		/* 按钮遮罩计算 */
		hasSelect() {
			return this.selectList.length ? '' : 'no-item'
		},
		/* 标记中文计算 */
		tagTxt() {
			console.log()
			if (!this.selectList.length) {
				return this.$t('header.sign')
			} else {
				console.log(this.$t('header.sign'))
				/* 先把所有未读的找出来 */
				const noReadIdList = this.list.filter((item) => !item.IsRead).map((item1) => item1.Id)
				/* 再把选中的未读找出来 */
				const selectNoReadIdList = this.selectList.filter((item) => noReadIdList.includes(item))
				/* 如果没有未读 */
				if (selectNoReadIdList.length) return this.$t('header.tagR')
				/* 如果全是未读 */
				if (selectNoReadIdList.length === this.selectList.length) return this.$t('header.tagR')
				return this.$t('header.tagW')
			}
		},
		listInfo() {
			return this.$store.state.List
		},
		list() {
			return this.$store.state.List.selectEmaList
		},
		FolderType() {
			return this.$store.state.List.seachForm.FolderType
		}
	},
	methods: {
		/* 取消不需要加载 */
		rightClick() {
			this.selectList = []
			this.$router.go(-1)
			this.$bus.$emit('needRefreshEmailList', false)
		},
		/* 操作需要加载 */
		selectBtnClick() {
			this.selectList = []
			this.$router.go(-1)
			this.$bus.$emit('needRefreshEmailList', true)
		},
		/* 单选 */
		selectById(e) {
			let IdList = [...this.selectList]
			if (IdList.includes(e)) {
				IdList = IdList.filter((item) => item !== e)
			} else {
				IdList.push(e)
			}
			if (IdList.length > 100) {
				return this.$toast({
					message: this.$t('home.maxList')
				})
			}
			this.selectList = IdList
		},
		/* 全选 */
		selectAll() {
			if (this.list.length !== this.selectList.length) {
				this.selectList = this.list.map((item) => item.Id)
			} else {
				this.selectList = []
			}
		},
		/* 点击标记 */
		handleClick() {
			if (this.selectList.length > 100) {
				return this.$toast({
					message: this.$t('home.maxList')
				})
			}
			switch (this.tagTxt) {
				case this.$t('header.sign'):
					return
				case this.$t('header.tagR'):
					this.tagNoRead(true)
					return
				case this.$t('header.tagW'):
					this.tagNoRead(false)
					return
				default:
					return
			}
		},
		/* 标记为未读*/
		tagNoRead(status) {
			console.log(status)
			const toast = this.$toast.loading({
				duration: 0,
				message: this.$t('home.loading'),
				forbidClick: true
			})
			this.$api
				.setReadStatusByIds({
					IsRead: status,
					EmailIds: this.selectList
				})
				.then((result) => {
					toast.clear()
					this.$toast.success({
						duration: 1000,
						message: this.$t('home.success')
					})
					this.selectBtnClick()
				})
		},
		/* 删除 */
		deleteListById() {
			if (!this.selectList.length) return
			let obj = {
				EmailIds: this.selectList,
				DeleteMode: 2 ////0-强制删除;1-软删除;2-移动删除(默认0)
			}
			if ([4, 2].includes(this.FolderType)) {
				obj.DeleteMode = 0
			}
			this.$dialog
				.confirm({
					title: this.$t('common.hint'),
					message: obj.DeleteMode === 0 ? this.$t('delMail.delAll') : this.$t('delMail.delTip')
				})
				.then(() => {
					// on close
					const toast = this.$toast.loading({
						duration: 0,
						message: this.$t('home.loading'),
						forbidClick: true
					})
					this.$api.deletEMAList(obj).then((res) => {
						toast.clear()
						this.$toast.success({
							duration: 1000,
							message: this.$t('delMail.delSuccess')
						})
						this.selectBtnClick()
					})
				})
		}
	}
}
</script>

<style lang="less" scoped>
.select-box {
	height: 100vh;
	position: fixed;
	top: 0;
	z-index: 2001;
	overflow: hidden;
	width: 100%;
	background-color: #fff;
}
.nav-box {
	position: sticky;
	top: 0;
}
.nav-left,
.nav-right {
	color: #005de5;
	font-size: 16px;
}
.select-list {
	overflow: auto;
	height: calc(100vh - 101px);
	margin-bottom: 55px;
}
.select-bottom {
	width: 100%;
	height: 55px;
	border-top: 1px solid #e5e5e5;
	position: fixed;
	bottom: 0;
	display: flex;
	background: #fafafb;
	.select-btn-item {
		font-size: 12px;
		color: #191919;
		width: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		img {
			width: 20px;
			height: 20px;
			margin-bottom: 2px;
		}
	}
}
.emil {
	font-size: 20px;
    margin-top: -3px;
    padding: 0 0 1px 0;
}
.no-item {
	opacity: 0.5;
}
</style>
